// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --color-letters: hsl(0, 0%, 30%);
    --color-bcg: hsl(0, 0%, 96%);
    --color-menu-bcg: hsl(183, 100%, 35%);
    --color-header-bcg: hsl(183, 100%, 40%);
    --color-borders: hsl(183, 100%, 40%);
    --color-project-icon: hsl(183, 84%, 34%);
    --color-add-button-hover: hsla(183, 100%, 45%);
    --color-red-error: hsl(0, 68%, 69%);
    --color-red-error-hover: hsla(0, 68%, 60%);
}

* {
    margin: 0px;
    padding: 0px;
    box-sizing: border-box;
}

body {
    min-height: 100%;
    width: 100%;
    font-family: "Roboto", sans-serif;
    display: flex;
    min-height: 100vh;
    flex-direction: column;
}

.main {
    display: flex;
    /* height: 100%; */
    flex: 1 0 auto;
}

.header {
    background-color: var(--color-header-bcg);
    height: 80px;
    display: flex;
    align-items: center;
    padding-left: 3rem;
    color: white;
}

.menu-btn {
    position: relative;
    display: none;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 5px;
    width: 40px;
    height: 40px;
    cursor: pointer;
    transition: all 0.5s ease-in-out;
    border-radius: 5px;
    background-color: var(--color-menu-bcg);
    margin-right: 2rem;
}

.menu-burger {
    width: 25px;
    height: 3px;
    border-radius: 3px;
    background: var(--color-bcg);
    transition: all 0.5s ease-in-out;
}

.menu-burger::before {
    transform: translateY(-8px);
}

.menu-burger::after {
    transform: translateY(8px);
}

.menu-btn.open .menu-burger:nth-child(2) {
    background: transparent;
}

.menu-btn.open .menu-burger:first-child {
    transform: rotate(45deg) translate(6px, 6px);
    width: 28px;
}

.menu-btn.open .menu-burger:last-child {
    transform: rotate(-45deg) translate(5.5px, -5.5px);
    width: 28px;
}

.header img {
    height: 38px;
    margin-right: 0.5rem;
}

.sidebar {
    min-width: 320px;
    background-color: var(--color-bcg);
    color: var(--color-letters);
    padding: 2.5rem 1.5rem;
    font-size: 0.5rem;
    font-size: clamp(0.5rem, 1vmin + 1rem, 18px);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    /* height: calc(100% - 80px); */
}

.sidebar-icons,
.content-title img {
    /* gray color on icons */
    filter: invert(35%) sepia(0%) saturate(1102%) hue-rotate(167deg)
        brightness(83%) contrast(94%);
    margin-right: 0.5rem;
}

.sidebar-nav:hover:not(.active-section) {
    border: 1px solid var(--color-header-bcg);
}

.project-edit-erase img:hover {
    scale: 1.15;
}

.sidebar-nav,
.modal-sidebar-item {
    display: flex;
    margin-bottom: 1.2rem;
    list-style: none;
    cursor: pointer;
    background-color: white;
    padding: 0.5rem 1rem;
    border: 1px solid transparent;
    border-radius: 5px;
}

.sidebar-link {
    display: flex;
}

.sidebar-nav p {
    -webkit-user-select: none; /* Safari */
    -ms-user-select: none; /* IE 10 and IE 11 */
    user-select: none; /* Standard syntax */
}

.sidebar-nav * {
    align-self: center;
}

.projects {
    font-size: 0.5rem;
    font-size: clamp(0.5rem, 1vmin + 1rem, 18px);
}

.project-name {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    width: 150px;
}

.projects-line {
    position: relative;
}

.projects-title {
    cursor: default;
    padding: 3rem 0 0.5rem 1rem;
    border-bottom: 1px solid var(--color-letters);
    margin-bottom: 1.5rem;
    font-weight: bold;
}

.projects-nav .sidebar-icons {
    width: 24px;
    height: 24px;
}

.project-edit-erase {
    display: flex;
    gap: 3px;
    margin-left: auto;
    /* gray color on icons */
    filter: invert(35%) sepia(0%) saturate(1102%) hue-rotate(167deg)
        brightness(83%) contrast(94%);
}

.projects-nav * {
    align-items: center;
}

.new-project-button,
.new-task-button {
    position: absolute;
    background-color: var(--color-header-bcg);
    height: 1.6rem;
    width: 1.6rem;
    font-size: 1.6rem;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: white;
    border-radius: 50%;
    cursor: pointer;
    top: 60%;
    right: 1%;
}

.new-project-button:hover,
.new-task-button:hover {
    transform: scale(1.3);
    transition: all 300ms ease-out;
    rotate: 90deg;
}

.new-task-button {
    top: 17%;
}

.main-content {
    width: calc(100vw - 320px);
    flex-basis: 1;
    font-size: clamp(0.5rem, 1vmin + 1rem, 18px);
    color: var(--color-letters);
    overflow: auto;
    text-align: center;
}

.content-title {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    color: var(--color-letters);
    margin-bottom: 3.5rem;
    margin: 0 auto 3.5rem auto;
    padding: 1rem 2.5rem 0 2.5rem;
}

a.select {
    text-decoration: none;
    color: inherit;
}

.content-title img {
    height: 48px;
    width: 48px;
}

.tasks-div {
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    padding: 0 2.5rem;
    width: clamp(250px, 92% + 1px, 1200px);
    text-align: left;
    box-sizing: border-box;
}

.tasks-title {
    padding: 0.5rem 1.5rem;
    border-bottom: 1px solid var(--color-letters);
    margin-bottom: 1.5rem;
    min-width: 600px;
    position: relative;
}

.task-title {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    max-width: 100%;
}

.completed-task {
    text-decoration: line-through;
}

.content {
    background-color: var(--color-bcg);
    padding: 0.2rem 0.7rem;
    display: grid;
    grid-template-columns: minmax(250px, auto) 1fr;
    align-items: center;
    margin-bottom: 1rem;
    min-width: 600px;
    max-width: 100%;
    box-sizing: border-box;
}

.content:hover {
    transform: scale(1.005);
    box-shadow: 3px 3px 5px 2px hsla(0, 0%, 0%, 0.4);
    transition: all 250ms ease-out;
}

.content:hover .checkmark {
    transform: scale(1.005);
}

.content > * > *,
.images img {
    align-self: center;
}

.images {
    display: grid;
    grid-template-rows: 1fr;
    grid-template-columns: 1fr 1fr;
    gap: 0.2rem;
}

.images img {
    filter: invert(35%) sepia(0%) saturate(1102%) hue-rotate(167deg)
        brightness(83%) contrast(94%);
}

.images img:hover {
    /* blueish color */
    filter: invert(58%) sepia(85%) saturate(1825%) hue-rotate(139deg)
        brightness(94%) contrast(101%);
    scale: 1.15;
}

.left-content,
.right-content {
    display: flex;
    gap: 1.2rem;
}

.right-content {
    justify-self: end;
}

/* Customize the label (the container) */
.container {
    display: block;
    position: relative;
    padding-left: 1rem;
    margin-bottom: 1.5rem;
    cursor: pointer;
    font-size: 22px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

/* Hide the browser's default checkbox */
.container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
}

/* Create a custom checkbox */
.checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 1.5rem;
    width: 1.5rem;
    border: 2px solid var(--color-header-bcg);
    border-radius: 5px;
    background-color: inherit;
}

/* When the checkbox is checked, add a green background */
.container input:checked ~ .checkmark {
    background-color: var(--color-header-bcg);
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
    content: "";
    position: absolute;
    display: none;
}

/* Show the checkmark when checked */
.container input:checked ~ .checkmark:after {
    display: block;
}

/* Style the checkmark/indicator */
.container .checkmark:after {
    left: 6px;
    top: 2px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
}

/* .checkbox {
  height: 1.5rem;
  width: 1.5rem;
  border: 2px solid var(--color-header-bcg);
  border-radius: 5px;
  display: inline-flex;
  cursor: pointer;
  position: relative;
} */

/* .checkmark {
  filter: invert(56%) sepia(76%) saturate(3647%) hue-rotate(148deg) brightness(97%) contrast(101%);
  scale: 1.5;
} */

.right-content img,
.checkbox {
    cursor: pointer;
    margin: 0;
    padding: 0;
}

.right-content {
    font-size: clamp(0.5rem, 1vmin + 1rem, 18px);
}

.detail {
    border: 2px solid var(--color-header-bcg);
    border-radius: 5px;
    padding: 0.4rem;
    color: var(--color-borders);
    cursor: pointer;
}

.detail:hover {
    background-color: var(--color-borders);
    border: 2px solid var(--color-borders);
    color: var(--color-bcg);
}

.right-content img {
    height: 24px;
    width: 24px;
}

.created-by {
    background-color: #1f2937;
    color: #e5e7eb;
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;
    padding: 25px;
}

.modal {
    display: flex;
    flex-direction: column;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(0);
    transition: 300ms ease-in-out;
    border: 1px solid black;
    z-index: 10;
    background-color: hsl(214, 32%, 91%);
    overflow: hidden;
}

.modal.active {
    transform: translate(-50%, -50%) scale(1);
    border: none;
    border-radius: 0.5rem;
}

.modal-header {
    display: flex;
    justify-content: space-between;
    height: 6vh;
    padding: 1rem;
    background-color: var(--color-header-bcg);
    position: relative;
}

.modal-header h2 {
    align-self: center;
    font-size: 1.2rem;
    font-size: clamp(
        1.2rem,
        1.0799999999999998rem + 0.6000000000000001vw,
        1.8rem
    );
    font-weight: 500;
    color: white;
}

.modal-body {
    display: flex;
    justify-content: space-between;
    background-color: white;
    height: 100%;
}

.modal-content {
    padding: 1.4rem;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    font-size: 0.9rem;
    font-size: clamp(0.9rem, 0.8300000000000001rem + 0.35vw, 1.25rem);
}

.modal-content .fields {
    display: flex;
    flex-direction: column;
    margin-bottom: 2rem;
}

.fields label {
    margin-bottom: 0.4rem;
    color: var(--color-letters);
}

.fields label::after,
.new-date-text::after,
.priority-text::after {
    content: "*";
    color: var(--color-red-error);
}

.fields input,
.fields textarea {
    border-radius: 0.3em;
    border: 1px solid lightgray;
    padding-left: 0.3rem;
    height: 2.5rem;
    font-size: 21px;
    color: var(--color-letters);
}

.fields input:focus,
.fields textarea:focus {
    outline: none;
    border: 2px solid var(--color-borders);
}

.fields textarea {
    padding-top: 0.5rem;
    height: 7rem;
}

.hide {
    display: none;
}

.modal-title-error,
.modal-details-error,
.modal-date-error,
.modal-priority-error {
    color: var(--color-red-error);
    font-size: 0.9rem;
    font-size: clamp(
        0.9rem,
        0.8400000000000001rem + 0.29999999999999993vw,
        1.2rem
    );
    margin-top: 0.3rem;
}

.icon-selection {
    margin-top: 2rem;
    color: var(--color-letters);
}

.icon-selection p {
    margin-bottom: 0.4rem;
}

.project-icons {
    display: flex;
    gap: 0.5rem;
    justify-content: space-between;
}

.project-icon {
    border: 1px solid var(--color-letters);
    height: 40px;
    width: 40px;
    border-radius: 5px;
    display: grid;
    cursor: pointer;
}

.project-icon:hover,
.active-icon {
    border: 1px solid var(--color-project-icon);
    filter: invert(58%) sepia(85%) saturate(1825%) hue-rotate(139deg)
        brightness(94%) contrast(101%);
}

.project-text-icon {
    display: flex;
    position: relative;
}

.icon-selection img {
    height: 30px;
    width: 30px;
    justify-self: center;
    align-self: center;
}

.modal-buttons {
    margin-top: 5rem;
    border-top: 1px solid var(--color-letters);
    padding: 1rem 0;
    display: flex;
    justify-content: flex-end;
}

.add-project-btn {
    padding: 0.7rem 1rem;
    font-size: inherit;
    background-color: var(--color-header-bcg);
    color: rgb(255, 255, 255);
    border-radius: 5px;
    border: none;
    cursor: pointer;
}

.add-project-btn:hover {
    background-color: var(--color-add-button-hover);
}

.delete-project-btn,
.delete-task-btn {
    padding: 0.7rem 1rem;
    font-size: inherit;
    background-color: var(--color-red-error);
    color: rgb(255, 255, 255);
    border-radius: 5px;
    border: none;
    cursor: pointer;
}

.delete-project-btn:hover,
.delete-task-btn:hover {
    background-color: var(--color-red-error-hover);
}

.delete-modal-header {
    background-color: var(--color-red-error);
}

.cancel-modal-btn,
.cancel-delete-modal-btn {
    background-color: white;
    color: var(--color-letters);
    padding: 0.7rem 1rem;
    border-radius: 5px;
    border: 1px solid var(--color-letters);
    cursor: pointer;
    margin-right: 0.5rem;
    font-size: inherit;
}

.cancel-modal-btn:hover {
    border: 1px solid var(--color-header-bcg);
    color: var(--color-header-bcg);
}

.cancel-delete-modal-btn:hover {
    border: 1px solid var(--color-red-error);
    color: var(--color-red-error);
}

.project-name-deletion,
.task-name-deletion {
    font-weight: bold;
}

.erase-project-text,
.erase-task-text {
    color: var(--color-letters);
}

.erase-project-text :first-child,
.erase-task-text :first-child {
    margin-bottom: 2rem;
}

#new-todo-details {
    height: 50%;
}

.new-todo-date {
    /* display: flex; */
    align-items: center;
    margin-bottom: 2rem;
}

.new-todo-date .new-date-text {
    margin-right: 1rem;
    color: var(--color-letters);
}

.new-todo-date input {
    font-size: 20px;
    border-color: var(--color-bcg);
    color: var(--color-letters);
    border-radius: 5px;
}

.priority {
    display: flex;
    align-items: center;
}

.priority-text {
    margin-right: 2rem;
    color: var(--color-letters);
}

.priority :not(.priority-text) {
    margin-right: 1rem;
    font-size: 0.8rem;
    font-size: clamp(0.8rem, 0.68rem + 0.5999999999999999vw, 1.4rem);
}

.low,
.medium,
.high {
    padding: 0.5rem 1rem;
    border-radius: 5px;
    cursor: pointer;
    font-weight: 500;
    /* height: max(); */
}

.low {
    border: 2px solid var(--color-borders);
    color: var(--color-borders);
}

.low:hover {
    background-color: var(--color-borders);
    color: white;
}

.medium {
    border: 2px solid rgb(253, 175, 1);
    color: rgb(253, 175, 1);
}

.medium:hover {
    background-color: rgb(253, 175, 1);
    color: white;
}

.high {
    border: 2px solid red;
    color: red;
}

.high:hover {
    background-color: red;
    color: white;
}

.low.priority-buttons.active-priority {
    background-color: var(--color-borders);
    color: white;
}

.medium.priority-buttons.active-priority {
    background-color: rgb(253, 175, 1);
    color: white;
}

.high.priority-buttons.active-priority {
    background-color: red;
    color: white;
}

.add-todo-btn {
    background-color: var(--color-header-bcg);
    color: rgb(255, 255, 255);
    padding: 0.7rem 1rem;
    border-radius: 5px;
    border: none;
    cursor: pointer;
    font-size: inherit;
}

.add-todo-btn:hover {
    background-color: var(--color-add-button-hover);
}

.modal-close-btn {
    font-size: 40px;
    color: white;
    position: absolute;
    cursor: pointer;
    top: -10%;
    right: 1%;
}

.modal-close-btn:hover {
    color: var(--color-letters);
}

#overlay {
    position: fixed;
    opacity: 0;
    transition: 300ms ease-in-out;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    pointer-events: none;
    background-color: rgba(0, 0, 0, 0.4);
    backdrop-filter: blur(5px);
}

#overlay.active {
    pointer-events: all;
    opacity: 1;
}

.active-section {
    background-color: var(--color-header-bcg);
    color: white;
}

.sidebar-nav.active-section .sidebar-icons,
.sidebar-nav.active-section .project-edit-erase {
    /* white color icon when active */
    filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(142deg)
        brightness(109%) contrast(101%);
}

.details-divs {
    display: grid;
    grid-template-columns: 1fr 2fr;
    border-bottom: 1px solid lightgray;
    padding: 1.5rem 0;
    width: clamp(300px, 30vw, 600px);
}

.details-divs:first-child {
    padding-top: 0.5rem;
}

.details-divs:last-child {
    border-bottom: none;
}

.details-left-column {
    color: var(--color-letters);
    font-weight: bold;
    margin-right: 0.5rem;
}

.details-right-column {
    color: var(--color-letters);
}

@media screen and (max-width: 1000px) {
    .menu-btn {
        display: flex;
    }

    .tasks-title {
        min-width: 90%;
    }

    

    #sidebar {
        transition: all 300ms ease-in-out;
        transform: translateX(-100%);
        position: absolute;
        height: calc(100% - 80px);
    }

    #sidebar.menu-active {
        transform: translateX(0);
        z-index: 4;
    }

    .footer {
        display: none;
    }

    .main-content {
        width: 100vw;
    }

    #menu-overlay {
        position: fixed;
        opacity: 0;
        transition: 500ms ease-in-out;
        top: 80px;
        left: 0;
        right: 0;
        bottom: 0;
        pointer-events: none;
        background-color: rgba(0, 0, 0, 0.4);
        backdrop-filter: blur(5px);
    }

    #menu-overlay.menu-active {
        pointer-events: all;
        opacity: 1;
    }
}

@media screen and (max-width: 750px) {
    .tasks-div {
        padding: 0;
    }

    .modal {
        width: 90%;
    }

    .main-content,
    .right-content {
        font-size: 0.9rem;
        font-size: clamp(0.9rem, 0.88rem + 0.09999999999999998vw, 1rem);
    }

    .content {
        grid-template-columns: 200px 1fr;
        min-width: 400px;
    }

    .right-content {
        justify-self: flex-start;
    }
}
`, "",{"version":3,"sources":["webpack://./src/styles/style.css"],"names":[],"mappings":"AAEA;IACI,gCAAgC;IAChC,4BAA4B;IAC5B,qCAAqC;IACrC,uCAAuC;IACvC,oCAAoC;IACpC,wCAAwC;IACxC,8CAA8C;IAC9C,mCAAmC;IACnC,0CAA0C;AAC9C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,iCAAiC;IACjC,aAAa;IACb,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,yCAAyC;IACzC,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gCAAgC;IAChC,kBAAkB;IAClB,uCAAuC;IACvC,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,4BAA4B;IAC5B,gCAAgC;AACpC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,4CAA4C;IAC5C,WAAW;AACf;;AAEA;IACI,kDAAkD;IAClD,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,kCAAkC;IAClC,2BAA2B;IAC3B,sBAAsB;IACtB,iBAAiB;IACjB,4CAA4C;IAC5C,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,+BAA+B;AACnC;;AAEA;;IAEI,wBAAwB;IACxB;qCACiC;IACjC,oBAAoB;AACxB;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,aAAa;IACb,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,uBAAuB;IACvB,oBAAoB;IACpB,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB,EAAE,WAAW;IACtC,qBAAqB,EAAE,oBAAoB;IAC3C,iBAAiB,EAAE,oBAAoB;AAC3C;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,4CAA4C;AAChD;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,2BAA2B;IAC3B,6CAA6C;IAC7C,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,iBAAiB;IACjB,wBAAwB;IACxB;qCACiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,kBAAkB;IAClB,yCAAyC;IACzC,cAAc;IACd,aAAa;IACb,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,QAAQ;IACR,SAAS;AACb;;AAEA;;IAEI,qBAAqB;IACrB,8BAA8B;IAC9B,aAAa;AACjB;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,0BAA0B;IAC1B,aAAa;IACb,4CAA4C;IAC5C,2BAA2B;IAC3B,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,2BAA2B;IAC3B,qBAAqB;IACrB,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,iBAAiB;IACjB,sCAAsC;IACtC,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,6CAA6C;IAC7C,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kCAAkC;IAClC,sBAAsB;IACtB,aAAa;IACb,8CAA8C;IAC9C,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,gDAAgD;IAChD,8BAA8B;AAClC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI;qCACiC;AACrC;;AAEA;IACI,kBAAkB;IAClB;sCACkC;IAClC,WAAW;AACf;;AAEA;;IAEI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA,wCAAwC;AACxC;IACI,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,sBAAsB;IACtB,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA,wCAAwC;AACxC;IACI,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,SAAS;IACT,QAAQ;AACZ;;AAEA,6BAA6B;AAC7B;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,cAAc;IACd,aAAa;IACb,yCAAyC;IACzC,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA,yDAAyD;AACzD;IACI,yCAAyC;AAC7C;;AAEA,6DAA6D;AAC7D;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;AACjB;;AAEA,oCAAoC;AACpC;IACI,cAAc;AAClB;;AAEA,kCAAkC;AAClC;IACI,SAAS;IACT,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,gCAAgC;IAChC,4BAA4B;IAC5B,wBAAwB;AAC5B;;AAEA;;;;;;;;GAQG;;AAEH;;;GAGG;;AAEH;;IAEI,eAAe;IACf,SAAS;IACT,UAAU;AACd;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,yCAAyC;IACzC,kBAAkB;IAClB,eAAe;IACf,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,sCAAsC;IACtC,sCAAsC;IACtC,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,QAAQ;IACR,SAAS;IACT,yCAAyC;IACzC,6BAA6B;IAC7B,uBAAuB;IACvB,WAAW;IACX,oCAAoC;IACpC,gBAAgB;AACpB;;AAEA;IACI,yCAAyC;IACzC,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,WAAW;IACX,aAAa;IACb,yCAAyC;IACzC,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB;;;;KAIC;IACD,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,iEAAiE;AACrE;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;;;IAGI,YAAY;IACZ,6BAA6B;AACjC;;AAEA;;IAEI,oBAAoB;IACpB,2BAA2B;IAC3B,oBAAoB;IACpB,cAAc;IACd,eAAe;IACf,2BAA2B;AAC/B;;AAEA;;IAEI,aAAa;IACb,sCAAsC;AAC1C;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;;;;IAII,6BAA6B;IAC7B,iBAAiB;IACjB;;;;KAIC;IACD,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,8BAA8B;AAClC;;AAEA;IACI,sCAAsC;IACtC,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,eAAe;AACnB;;AAEA;;IAEI,2CAA2C;IAC3C;sCACkC;AACtC;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,0CAA0C;IAC1C,eAAe;IACf,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,yCAAyC;IACzC,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,+CAA+C;AACnD;;AAEA;;IAEI,oBAAoB;IACpB,kBAAkB;IAClB,wCAAwC;IACxC,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,eAAe;AACnB;;AAEA;;IAEI,8CAA8C;AAClD;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;;IAEI,uBAAuB;IACvB,2BAA2B;IAC3B,oBAAoB;IACpB,kBAAkB;IAClB,sCAAsC;IACtC,eAAe;IACf,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,yCAAyC;IACzC,8BAA8B;AAClC;;AAEA;IACI,wCAAwC;IACxC,6BAA6B;AACjC;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,8BAA8B;IAC9B,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,gEAAgE;AACpE;;AAEA;;;IAGI,oBAAoB;IACpB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,sCAAsC;IACtC,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;IACtC,YAAY;AAChB;;AAEA;IACI,kCAAkC;IAClC,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;IAClC,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,sCAAsC;IACtC,YAAY;AAChB;;AAEA;IACI,kCAAkC;IAClC,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,yCAAyC;IACzC,yBAAyB;IACzB,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,SAAS;IACT,SAAS;AACb;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,UAAU;IACV,6BAA6B;IAC7B,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oBAAoB;IACpB,oCAAoC;IACpC,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,yCAAyC;IACzC,YAAY;AAChB;;AAEA;;IAEI,iCAAiC;IACjC;uCACmC;AACvC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,kCAAkC;IAClC,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;;;;IAIA;QACI,iCAAiC;QACjC,4BAA4B;QAC5B,kBAAkB;QAClB,yBAAyB;IAC7B;;IAEA;QACI,wBAAwB;QACxB,UAAU;IACd;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,UAAU;QACV,6BAA6B;QAC7B,SAAS;QACT,OAAO;QACP,QAAQ;QACR,SAAS;QACT,oBAAoB;QACpB,oCAAoC;QACpC,0BAA0B;IAC9B;;IAEA;QACI,mBAAmB;QACnB,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;;IAEA;;QAEI,iBAAiB;QACjB,+DAA+D;IACnE;;IAEA;QACI,gCAAgC;QAChC,gBAAgB;IACpB;;IAEA;QACI,wBAAwB;IAC5B;AACJ","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700;900&display=swap\");\r\n\r\n:root {\r\n    --color-letters: hsl(0, 0%, 30%);\r\n    --color-bcg: hsl(0, 0%, 96%);\r\n    --color-menu-bcg: hsl(183, 100%, 35%);\r\n    --color-header-bcg: hsl(183, 100%, 40%);\r\n    --color-borders: hsl(183, 100%, 40%);\r\n    --color-project-icon: hsl(183, 84%, 34%);\r\n    --color-add-button-hover: hsla(183, 100%, 45%);\r\n    --color-red-error: hsl(0, 68%, 69%);\r\n    --color-red-error-hover: hsla(0, 68%, 60%);\r\n}\r\n\r\n* {\r\n    margin: 0px;\r\n    padding: 0px;\r\n    box-sizing: border-box;\r\n}\r\n\r\nbody {\r\n    min-height: 100%;\r\n    width: 100%;\r\n    font-family: \"Roboto\", sans-serif;\r\n    display: flex;\r\n    min-height: 100vh;\r\n    flex-direction: column;\r\n}\r\n\r\n.main {\r\n    display: flex;\r\n    /* height: 100%; */\r\n    flex: 1 0 auto;\r\n}\r\n\r\n.header {\r\n    background-color: var(--color-header-bcg);\r\n    height: 80px;\r\n    display: flex;\r\n    align-items: center;\r\n    padding-left: 3rem;\r\n    color: white;\r\n}\r\n\r\n.menu-btn {\r\n    position: relative;\r\n    display: none;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    gap: 5px;\r\n    width: 40px;\r\n    height: 40px;\r\n    cursor: pointer;\r\n    transition: all 0.5s ease-in-out;\r\n    border-radius: 5px;\r\n    background-color: var(--color-menu-bcg);\r\n    margin-right: 2rem;\r\n}\r\n\r\n.menu-burger {\r\n    width: 25px;\r\n    height: 3px;\r\n    border-radius: 3px;\r\n    background: var(--color-bcg);\r\n    transition: all 0.5s ease-in-out;\r\n}\r\n\r\n.menu-burger::before {\r\n    transform: translateY(-8px);\r\n}\r\n\r\n.menu-burger::after {\r\n    transform: translateY(8px);\r\n}\r\n\r\n.menu-btn.open .menu-burger:nth-child(2) {\r\n    background: transparent;\r\n}\r\n\r\n.menu-btn.open .menu-burger:first-child {\r\n    transform: rotate(45deg) translate(6px, 6px);\r\n    width: 28px;\r\n}\r\n\r\n.menu-btn.open .menu-burger:last-child {\r\n    transform: rotate(-45deg) translate(5.5px, -5.5px);\r\n    width: 28px;\r\n}\r\n\r\n.header img {\r\n    height: 38px;\r\n    margin-right: 0.5rem;\r\n}\r\n\r\n.sidebar {\r\n    min-width: 320px;\r\n    background-color: var(--color-bcg);\r\n    color: var(--color-letters);\r\n    padding: 2.5rem 1.5rem;\r\n    font-size: 0.5rem;\r\n    font-size: clamp(0.5rem, 1vmin + 1rem, 18px);\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: space-between;\r\n    /* height: calc(100% - 80px); */\r\n}\r\n\r\n.sidebar-icons,\r\n.content-title img {\r\n    /* gray color on icons */\r\n    filter: invert(35%) sepia(0%) saturate(1102%) hue-rotate(167deg)\r\n        brightness(83%) contrast(94%);\r\n    margin-right: 0.5rem;\r\n}\r\n\r\n.sidebar-nav:hover:not(.active-section) {\r\n    border: 1px solid var(--color-header-bcg);\r\n}\r\n\r\n.project-edit-erase img:hover {\r\n    scale: 1.15;\r\n}\r\n\r\n.sidebar-nav,\r\n.modal-sidebar-item {\r\n    display: flex;\r\n    margin-bottom: 1.2rem;\r\n    list-style: none;\r\n    cursor: pointer;\r\n    background-color: white;\r\n    padding: 0.5rem 1rem;\r\n    border: 1px solid transparent;\r\n    border-radius: 5px;\r\n}\r\n\r\n.sidebar-link {\r\n    display: flex;\r\n}\r\n\r\n.sidebar-nav p {\r\n    -webkit-user-select: none; /* Safari */\r\n    -ms-user-select: none; /* IE 10 and IE 11 */\r\n    user-select: none; /* Standard syntax */\r\n}\r\n\r\n.sidebar-nav * {\r\n    align-self: center;\r\n}\r\n\r\n.projects {\r\n    font-size: 0.5rem;\r\n    font-size: clamp(0.5rem, 1vmin + 1rem, 18px);\r\n}\r\n\r\n.project-name {\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    width: 150px;\r\n}\r\n\r\n.projects-line {\r\n    position: relative;\r\n}\r\n\r\n.projects-title {\r\n    cursor: default;\r\n    padding: 3rem 0 0.5rem 1rem;\r\n    border-bottom: 1px solid var(--color-letters);\r\n    margin-bottom: 1.5rem;\r\n    font-weight: bold;\r\n}\r\n\r\n.projects-nav .sidebar-icons {\r\n    width: 24px;\r\n    height: 24px;\r\n}\r\n\r\n.project-edit-erase {\r\n    display: flex;\r\n    gap: 3px;\r\n    margin-left: auto;\r\n    /* gray color on icons */\r\n    filter: invert(35%) sepia(0%) saturate(1102%) hue-rotate(167deg)\r\n        brightness(83%) contrast(94%);\r\n}\r\n\r\n.projects-nav * {\r\n    align-items: center;\r\n}\r\n\r\n.new-project-button,\r\n.new-task-button {\r\n    position: absolute;\r\n    background-color: var(--color-header-bcg);\r\n    height: 1.6rem;\r\n    width: 1.6rem;\r\n    font-size: 1.6rem;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    text-align: center;\r\n    color: white;\r\n    border-radius: 50%;\r\n    cursor: pointer;\r\n    top: 60%;\r\n    right: 1%;\r\n}\r\n\r\n.new-project-button:hover,\r\n.new-task-button:hover {\r\n    transform: scale(1.3);\r\n    transition: all 300ms ease-out;\r\n    rotate: 90deg;\r\n}\r\n\r\n.new-task-button {\r\n    top: 17%;\r\n}\r\n\r\n.main-content {\r\n    width: calc(100vw - 320px);\r\n    flex-basis: 1;\r\n    font-size: clamp(0.5rem, 1vmin + 1rem, 18px);\r\n    color: var(--color-letters);\r\n    overflow: auto;\r\n    text-align: center;\r\n}\r\n\r\n.content-title {\r\n    display: inline-flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    color: var(--color-letters);\r\n    margin-bottom: 3.5rem;\r\n    margin: 0 auto 3.5rem auto;\r\n    padding: 1rem 2.5rem 0 2.5rem;\r\n}\r\n\r\na.select {\r\n    text-decoration: none;\r\n    color: inherit;\r\n}\r\n\r\n.content-title img {\r\n    height: 48px;\r\n    width: 48px;\r\n}\r\n\r\n.tasks-div {\r\n    display: flex;\r\n    flex-direction: column;\r\n    margin: 0 auto;\r\n    padding: 0 2.5rem;\r\n    width: clamp(250px, 92% + 1px, 1200px);\r\n    text-align: left;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.tasks-title {\r\n    padding: 0.5rem 1.5rem;\r\n    border-bottom: 1px solid var(--color-letters);\r\n    margin-bottom: 1.5rem;\r\n    min-width: 600px;\r\n    position: relative;\r\n}\r\n\r\n.task-title {\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    max-width: 100%;\r\n}\r\n\r\n.completed-task {\r\n    text-decoration: line-through;\r\n}\r\n\r\n.content {\r\n    background-color: var(--color-bcg);\r\n    padding: 0.2rem 0.7rem;\r\n    display: grid;\r\n    grid-template-columns: minmax(250px, auto) 1fr;\r\n    align-items: center;\r\n    margin-bottom: 1rem;\r\n    min-width: 600px;\r\n    max-width: 100%;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.content:hover {\r\n    transform: scale(1.005);\r\n    box-shadow: 3px 3px 5px 2px hsla(0, 0%, 0%, 0.4);\r\n    transition: all 250ms ease-out;\r\n}\r\n\r\n.content:hover .checkmark {\r\n    transform: scale(1.005);\r\n}\r\n\r\n.content > * > *,\r\n.images img {\r\n    align-self: center;\r\n}\r\n\r\n.images {\r\n    display: grid;\r\n    grid-template-rows: 1fr;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 0.2rem;\r\n}\r\n\r\n.images img {\r\n    filter: invert(35%) sepia(0%) saturate(1102%) hue-rotate(167deg)\r\n        brightness(83%) contrast(94%);\r\n}\r\n\r\n.images img:hover {\r\n    /* blueish color */\r\n    filter: invert(58%) sepia(85%) saturate(1825%) hue-rotate(139deg)\r\n        brightness(94%) contrast(101%);\r\n    scale: 1.15;\r\n}\r\n\r\n.left-content,\r\n.right-content {\r\n    display: flex;\r\n    gap: 1.2rem;\r\n}\r\n\r\n.right-content {\r\n    justify-self: end;\r\n}\r\n\r\n/* Customize the label (the container) */\r\n.container {\r\n    display: block;\r\n    position: relative;\r\n    padding-left: 1rem;\r\n    margin-bottom: 1.5rem;\r\n    cursor: pointer;\r\n    font-size: 22px;\r\n    -webkit-user-select: none;\r\n    -moz-user-select: none;\r\n    -ms-user-select: none;\r\n    user-select: none;\r\n}\r\n\r\n/* Hide the browser's default checkbox */\r\n.container input {\r\n    position: absolute;\r\n    opacity: 0;\r\n    cursor: pointer;\r\n    height: 0;\r\n    width: 0;\r\n}\r\n\r\n/* Create a custom checkbox */\r\n.checkmark {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    height: 1.5rem;\r\n    width: 1.5rem;\r\n    border: 2px solid var(--color-header-bcg);\r\n    border-radius: 5px;\r\n    background-color: inherit;\r\n}\r\n\r\n/* When the checkbox is checked, add a green background */\r\n.container input:checked ~ .checkmark {\r\n    background-color: var(--color-header-bcg);\r\n}\r\n\r\n/* Create the checkmark/indicator (hidden when not checked) */\r\n.checkmark:after {\r\n    content: \"\";\r\n    position: absolute;\r\n    display: none;\r\n}\r\n\r\n/* Show the checkmark when checked */\r\n.container input:checked ~ .checkmark:after {\r\n    display: block;\r\n}\r\n\r\n/* Style the checkmark/indicator */\r\n.container .checkmark:after {\r\n    left: 6px;\r\n    top: 2px;\r\n    width: 5px;\r\n    height: 10px;\r\n    border: solid white;\r\n    border-width: 0 3px 3px 0;\r\n    -webkit-transform: rotate(45deg);\r\n    -ms-transform: rotate(45deg);\r\n    transform: rotate(45deg);\r\n}\r\n\r\n/* .checkbox {\r\n  height: 1.5rem;\r\n  width: 1.5rem;\r\n  border: 2px solid var(--color-header-bcg);\r\n  border-radius: 5px;\r\n  display: inline-flex;\r\n  cursor: pointer;\r\n  position: relative;\r\n} */\r\n\r\n/* .checkmark {\r\n  filter: invert(56%) sepia(76%) saturate(3647%) hue-rotate(148deg) brightness(97%) contrast(101%);\r\n  scale: 1.5;\r\n} */\r\n\r\n.right-content img,\r\n.checkbox {\r\n    cursor: pointer;\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\n.right-content {\r\n    font-size: clamp(0.5rem, 1vmin + 1rem, 18px);\r\n}\r\n\r\n.detail {\r\n    border: 2px solid var(--color-header-bcg);\r\n    border-radius: 5px;\r\n    padding: 0.4rem;\r\n    color: var(--color-borders);\r\n    cursor: pointer;\r\n}\r\n\r\n.detail:hover {\r\n    background-color: var(--color-borders);\r\n    border: 2px solid var(--color-borders);\r\n    color: var(--color-bcg);\r\n}\r\n\r\n.right-content img {\r\n    height: 24px;\r\n    width: 24px;\r\n}\r\n\r\n.created-by {\r\n    background-color: #1f2937;\r\n    color: #e5e7eb;\r\n    display: flex;\r\n    text-align: center;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: 25px;\r\n}\r\n\r\n.modal {\r\n    display: flex;\r\n    flex-direction: column;\r\n    position: fixed;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%) scale(0);\r\n    transition: 300ms ease-in-out;\r\n    border: 1px solid black;\r\n    z-index: 10;\r\n    background-color: hsl(214, 32%, 91%);\r\n    overflow: hidden;\r\n}\r\n\r\n.modal.active {\r\n    transform: translate(-50%, -50%) scale(1);\r\n    border: none;\r\n    border-radius: 0.5rem;\r\n}\r\n\r\n.modal-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    height: 6vh;\r\n    padding: 1rem;\r\n    background-color: var(--color-header-bcg);\r\n    position: relative;\r\n}\r\n\r\n.modal-header h2 {\r\n    align-self: center;\r\n    font-size: 1.2rem;\r\n    font-size: clamp(\r\n        1.2rem,\r\n        1.0799999999999998rem + 0.6000000000000001vw,\r\n        1.8rem\r\n    );\r\n    font-weight: 500;\r\n    color: white;\r\n}\r\n\r\n.modal-body {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    background-color: white;\r\n    height: 100%;\r\n}\r\n\r\n.modal-content {\r\n    padding: 1.4rem;\r\n    height: 100%;\r\n    width: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    font-size: 0.9rem;\r\n    font-size: clamp(0.9rem, 0.8300000000000001rem + 0.35vw, 1.25rem);\r\n}\r\n\r\n.modal-content .fields {\r\n    display: flex;\r\n    flex-direction: column;\r\n    margin-bottom: 2rem;\r\n}\r\n\r\n.fields label {\r\n    margin-bottom: 0.4rem;\r\n    color: var(--color-letters);\r\n}\r\n\r\n.fields label::after,\r\n.new-date-text::after,\r\n.priority-text::after {\r\n    content: \"*\";\r\n    color: var(--color-red-error);\r\n}\r\n\r\n.fields input,\r\n.fields textarea {\r\n    border-radius: 0.3em;\r\n    border: 1px solid lightgray;\r\n    padding-left: 0.3rem;\r\n    height: 2.5rem;\r\n    font-size: 21px;\r\n    color: var(--color-letters);\r\n}\r\n\r\n.fields input:focus,\r\n.fields textarea:focus {\r\n    outline: none;\r\n    border: 2px solid var(--color-borders);\r\n}\r\n\r\n.fields textarea {\r\n    padding-top: 0.5rem;\r\n    height: 7rem;\r\n}\r\n\r\n.hide {\r\n    display: none;\r\n}\r\n\r\n.modal-title-error,\r\n.modal-details-error,\r\n.modal-date-error,\r\n.modal-priority-error {\r\n    color: var(--color-red-error);\r\n    font-size: 0.9rem;\r\n    font-size: clamp(\r\n        0.9rem,\r\n        0.8400000000000001rem + 0.29999999999999993vw,\r\n        1.2rem\r\n    );\r\n    margin-top: 0.3rem;\r\n}\r\n\r\n.icon-selection {\r\n    margin-top: 2rem;\r\n    color: var(--color-letters);\r\n}\r\n\r\n.icon-selection p {\r\n    margin-bottom: 0.4rem;\r\n}\r\n\r\n.project-icons {\r\n    display: flex;\r\n    gap: 0.5rem;\r\n    justify-content: space-between;\r\n}\r\n\r\n.project-icon {\r\n    border: 1px solid var(--color-letters);\r\n    height: 40px;\r\n    width: 40px;\r\n    border-radius: 5px;\r\n    display: grid;\r\n    cursor: pointer;\r\n}\r\n\r\n.project-icon:hover,\r\n.active-icon {\r\n    border: 1px solid var(--color-project-icon);\r\n    filter: invert(58%) sepia(85%) saturate(1825%) hue-rotate(139deg)\r\n        brightness(94%) contrast(101%);\r\n}\r\n\r\n.project-text-icon {\r\n    display: flex;\r\n    position: relative;\r\n}\r\n\r\n.icon-selection img {\r\n    height: 30px;\r\n    width: 30px;\r\n    justify-self: center;\r\n    align-self: center;\r\n}\r\n\r\n.modal-buttons {\r\n    margin-top: 5rem;\r\n    border-top: 1px solid var(--color-letters);\r\n    padding: 1rem 0;\r\n    display: flex;\r\n    justify-content: flex-end;\r\n}\r\n\r\n.add-project-btn {\r\n    padding: 0.7rem 1rem;\r\n    font-size: inherit;\r\n    background-color: var(--color-header-bcg);\r\n    color: rgb(255, 255, 255);\r\n    border-radius: 5px;\r\n    border: none;\r\n    cursor: pointer;\r\n}\r\n\r\n.add-project-btn:hover {\r\n    background-color: var(--color-add-button-hover);\r\n}\r\n\r\n.delete-project-btn,\r\n.delete-task-btn {\r\n    padding: 0.7rem 1rem;\r\n    font-size: inherit;\r\n    background-color: var(--color-red-error);\r\n    color: rgb(255, 255, 255);\r\n    border-radius: 5px;\r\n    border: none;\r\n    cursor: pointer;\r\n}\r\n\r\n.delete-project-btn:hover,\r\n.delete-task-btn:hover {\r\n    background-color: var(--color-red-error-hover);\r\n}\r\n\r\n.delete-modal-header {\r\n    background-color: var(--color-red-error);\r\n}\r\n\r\n.cancel-modal-btn,\r\n.cancel-delete-modal-btn {\r\n    background-color: white;\r\n    color: var(--color-letters);\r\n    padding: 0.7rem 1rem;\r\n    border-radius: 5px;\r\n    border: 1px solid var(--color-letters);\r\n    cursor: pointer;\r\n    margin-right: 0.5rem;\r\n    font-size: inherit;\r\n}\r\n\r\n.cancel-modal-btn:hover {\r\n    border: 1px solid var(--color-header-bcg);\r\n    color: var(--color-header-bcg);\r\n}\r\n\r\n.cancel-delete-modal-btn:hover {\r\n    border: 1px solid var(--color-red-error);\r\n    color: var(--color-red-error);\r\n}\r\n\r\n.project-name-deletion,\r\n.task-name-deletion {\r\n    font-weight: bold;\r\n}\r\n\r\n.erase-project-text,\r\n.erase-task-text {\r\n    color: var(--color-letters);\r\n}\r\n\r\n.erase-project-text :first-child,\r\n.erase-task-text :first-child {\r\n    margin-bottom: 2rem;\r\n}\r\n\r\n#new-todo-details {\r\n    height: 50%;\r\n}\r\n\r\n.new-todo-date {\r\n    /* display: flex; */\r\n    align-items: center;\r\n    margin-bottom: 2rem;\r\n}\r\n\r\n.new-todo-date .new-date-text {\r\n    margin-right: 1rem;\r\n    color: var(--color-letters);\r\n}\r\n\r\n.new-todo-date input {\r\n    font-size: 20px;\r\n    border-color: var(--color-bcg);\r\n    color: var(--color-letters);\r\n    border-radius: 5px;\r\n}\r\n\r\n.priority {\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.priority-text {\r\n    margin-right: 2rem;\r\n    color: var(--color-letters);\r\n}\r\n\r\n.priority :not(.priority-text) {\r\n    margin-right: 1rem;\r\n    font-size: 0.8rem;\r\n    font-size: clamp(0.8rem, 0.68rem + 0.5999999999999999vw, 1.4rem);\r\n}\r\n\r\n.low,\r\n.medium,\r\n.high {\r\n    padding: 0.5rem 1rem;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    font-weight: 500;\r\n    /* height: max(); */\r\n}\r\n\r\n.low {\r\n    border: 2px solid var(--color-borders);\r\n    color: var(--color-borders);\r\n}\r\n\r\n.low:hover {\r\n    background-color: var(--color-borders);\r\n    color: white;\r\n}\r\n\r\n.medium {\r\n    border: 2px solid rgb(253, 175, 1);\r\n    color: rgb(253, 175, 1);\r\n}\r\n\r\n.medium:hover {\r\n    background-color: rgb(253, 175, 1);\r\n    color: white;\r\n}\r\n\r\n.high {\r\n    border: 2px solid red;\r\n    color: red;\r\n}\r\n\r\n.high:hover {\r\n    background-color: red;\r\n    color: white;\r\n}\r\n\r\n.low.priority-buttons.active-priority {\r\n    background-color: var(--color-borders);\r\n    color: white;\r\n}\r\n\r\n.medium.priority-buttons.active-priority {\r\n    background-color: rgb(253, 175, 1);\r\n    color: white;\r\n}\r\n\r\n.high.priority-buttons.active-priority {\r\n    background-color: red;\r\n    color: white;\r\n}\r\n\r\n.add-todo-btn {\r\n    background-color: var(--color-header-bcg);\r\n    color: rgb(255, 255, 255);\r\n    padding: 0.7rem 1rem;\r\n    border-radius: 5px;\r\n    border: none;\r\n    cursor: pointer;\r\n    font-size: inherit;\r\n}\r\n\r\n.add-todo-btn:hover {\r\n    background-color: var(--color-add-button-hover);\r\n}\r\n\r\n.modal-close-btn {\r\n    font-size: 40px;\r\n    color: white;\r\n    position: absolute;\r\n    cursor: pointer;\r\n    top: -10%;\r\n    right: 1%;\r\n}\r\n\r\n.modal-close-btn:hover {\r\n    color: var(--color-letters);\r\n}\r\n\r\n#overlay {\r\n    position: fixed;\r\n    opacity: 0;\r\n    transition: 300ms ease-in-out;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    pointer-events: none;\r\n    background-color: rgba(0, 0, 0, 0.4);\r\n    backdrop-filter: blur(5px);\r\n}\r\n\r\n#overlay.active {\r\n    pointer-events: all;\r\n    opacity: 1;\r\n}\r\n\r\n.active-section {\r\n    background-color: var(--color-header-bcg);\r\n    color: white;\r\n}\r\n\r\n.sidebar-nav.active-section .sidebar-icons,\r\n.sidebar-nav.active-section .project-edit-erase {\r\n    /* white color icon when active */\r\n    filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(142deg)\r\n        brightness(109%) contrast(101%);\r\n}\r\n\r\n.details-divs {\r\n    display: grid;\r\n    grid-template-columns: 1fr 2fr;\r\n    border-bottom: 1px solid lightgray;\r\n    padding: 1.5rem 0;\r\n    width: clamp(300px, 30vw, 600px);\r\n}\r\n\r\n.details-divs:first-child {\r\n    padding-top: 0.5rem;\r\n}\r\n\r\n.details-divs:last-child {\r\n    border-bottom: none;\r\n}\r\n\r\n.details-left-column {\r\n    color: var(--color-letters);\r\n    font-weight: bold;\r\n    margin-right: 0.5rem;\r\n}\r\n\r\n.details-right-column {\r\n    color: var(--color-letters);\r\n}\r\n\r\n@media screen and (max-width: 1000px) {\r\n    .menu-btn {\r\n        display: flex;\r\n    }\r\n\r\n    .tasks-title {\r\n        min-width: 90%;\r\n    }\r\n\r\n    \r\n\r\n    #sidebar {\r\n        transition: all 300ms ease-in-out;\r\n        transform: translateX(-100%);\r\n        position: absolute;\r\n        height: calc(100% - 80px);\r\n    }\r\n\r\n    #sidebar.menu-active {\r\n        transform: translateX(0);\r\n        z-index: 4;\r\n    }\r\n\r\n    .footer {\r\n        display: none;\r\n    }\r\n\r\n    .main-content {\r\n        width: 100vw;\r\n    }\r\n\r\n    #menu-overlay {\r\n        position: fixed;\r\n        opacity: 0;\r\n        transition: 500ms ease-in-out;\r\n        top: 80px;\r\n        left: 0;\r\n        right: 0;\r\n        bottom: 0;\r\n        pointer-events: none;\r\n        background-color: rgba(0, 0, 0, 0.4);\r\n        backdrop-filter: blur(5px);\r\n    }\r\n\r\n    #menu-overlay.menu-active {\r\n        pointer-events: all;\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n@media screen and (max-width: 750px) {\r\n    .tasks-div {\r\n        padding: 0;\r\n    }\r\n\r\n    .modal {\r\n        width: 90%;\r\n    }\r\n\r\n    .main-content,\r\n    .right-content {\r\n        font-size: 0.9rem;\r\n        font-size: clamp(0.9rem, 0.88rem + 0.09999999999999998vw, 1rem);\r\n    }\r\n\r\n    .content {\r\n        grid-template-columns: 200px 1fr;\r\n        min-width: 400px;\r\n    }\r\n\r\n    .right-content {\r\n        justify-self: flex-start;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
